module.exports = __webpack_public_path__ + "assets/img/27_1280.cc57913b.jpg";